var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gas Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_landing-page-default",
    transform: "translate(-114.000000, -427.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accounts",
    transform: "translate(100.000000, 354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Tile",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-container",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4296188,0 C13.306461,1.52381714 14.7873846,3.36995253 15.872434,5.53846154 C16.9574834,7.70697055 17.5,10.0366176 17.5,12.5274725 C17.5,14.5787648 16.7668695,16.336989 15.3005865,17.8021978 C13.8343035,19.2674066 12.067459,20 10,20 C7.93254098,20 6.16569648,19.2674066 4.69941349,17.8021978 C3.2331305,16.336989 2.5,14.5787648 2.5,12.5274725 C2.5,9.36262154 3.51172009,6.57876659 5.53519062,4.17582418 L5.49120235,4.52747253 C5.49120235,5.49451033 5.82111107,6.31501495 6.48093842,6.98901099 C7.14076576,7.66300703 7.95454062,8 8.92228739,8 C9.8607085,8 10.6231642,7.66300703 11.2096774,6.98901099 C11.7961906,6.31501495 12.0894428,5.49451033 12.0894428,4.52747253 C12.0894428,3.91208484 12.0381237,3.23077297 11.9354839,2.48351648 C11.8328441,1.73626 11.7228745,1.14285934 11.6055718,0.703296703 L11.4296188,0 Z M8.68128655,17 C10.0224239,17 11.160814,16.5212814 12.0964912,15.5638298 C13.0321684,14.6063782 13.5,13.4574535 13.5,12.1170213 C13.5,10.6808439 13.297273,9.30851718 12.8918129,8 C11.9561357,9.30851718 10.4278858,10.186168 8.30701754,10.6329787 C7.40252959,10.824469 6.70857942,11.1994653 6.2251462,11.7579787 C5.74171298,12.3164922 5.5,12.9946769 5.5,13.7925532 C5.5,14.6861747 5.81188772,15.4441458 6.43567251,16.0664894 C7.05945731,16.6888329 7.80798784,17 8.68128655,17 Z",
    id: "\\uF161-copy"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.0fae7512c2221004dfcb7c806951def6.svg";
export { ForwardRef as ReactComponent };